import React, { useState } from "react";
import "./projectCard.css";
import { useNavigate } from "react-router-dom";
import ProjectModal from "../projectModal/ProjectModal";

const ProjectCard = ({ projectinfo }) => {
  const [show, setShow] = useState(false);
  const [overlay, setOverlay] = useState(false);
  function setLoader() {
    setOverlay(true);
    if (!show) {
      setShow(true);
    }
    setTimeout(() => {
      setOverlay(false);
    }, 700);
  }
  return (
    <>
      <div className="m-2 ">
        <div className="project-card" onClick={() => setLoader()}>
          <div className=" projct-img-container">
            <img
              src={projectinfo?.img?.url}
              className="card-img-top "
              alt="card-img-top"
            ></img>
          </div>
          <div className="card-body">
            <p className="project-title secondary-text p-0 ">
              {projectinfo?.title1[0]?.text}
            </p>
            <p className="project-description  ">
              {projectinfo?.description1[0]?.text.slice(
                0,
                projectinfo?.slice_number[0]?.text
              )}
            </p>
          </div>
        </div>
      </div>
      {overlay ? <div className="overlaylooker"></div> : null}
      <ProjectModal
        show={show}
        setShow={setShow}
        info={projectinfo}
      ></ProjectModal>
    </>
  );
};

export default ProjectCard;
